import consumer from './cable';

$(document).ready(() => {
  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof(iframe) == 'object')) {
      consumer.disconnect();
      $("#questionnairePending").addClass('d-none');
      $("#questionnaireError").removeClass('d-none');
    }
  };

  function generateUniversignIframe(signerId) {
    const configuration = {};
    const iframeEndpoint = $('#questionnaire-iframe').data('universign-iframe-endpoint');
    /**
    * The universignSigInit function add an iframe element as child of element with
    * id attribute equals to containerId parameter, the attribute src is set from
    * the universignUrl variable, it is the url of the website to be integrated in
    * the iframe, the width and height of the iframe will take 100% of its
    * container.
    *
    * @param {string} containerId The id of the element in which we will inject
    * the iframe.
    * @param {string} signerId The identifier of transaction.
    * @param {object} configuration The options list to customize the iframe:
    * * redirectionMode {string} This params have two possible values: IN or OUT,
    * the dafault value is OUT,
    * if the value of this params is equal to OUT the redirection will be done
    * outside the iframe(in website container of the iframe),
    * if the value of this params is equal to ÌN the redirection will be done
    * inside the iframe,
    * if the value of this params is otherwise, an exception will be triggered.
    **/

    universignSigInit('questionnaire-iframe', signerId, configuration, iframeEndpoint);
  };

  let docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  if ($('#mif2-questionnaire-id').length) {
    consumer.subscriptions.create(
      { channel: 'Mif2QuestionnaireChannel', mif2_questionnaire_id: $('#mif2-questionnaire-id').data('id') }, {
      received(data) {
        try {
          if (data.status == 'success') {
            clearTimeout(docliftDoesNotAnswerTimer);

            generateUniversignIframe(data.e_sign_id);

            $('#contractLoadedButton').prop('disabled', false);
            $('#questionnairePending #step-title').text($('#questionnairePending').data('title-in-case-of-doc-ready'));
            $('#questionnairePending #step-image').attr('src', $('#questionnairePending').data('image-in-case-of-doc-ready'));
            $('#generatingDocInProgressExplanations').addClass('d-none');
            $('#generatingDocReadyExplanations').removeClass('d-none');

            $('#contractLoadedButton').on('click', (e) => {
              $('#questionnaire-iframe').removeClass('d-none');
              $('#questionnairePending').addClass('d-none');
            });
          } else {
            setTimeout(() => {
              $('#questionnairePending').addClass('d-none');
              $('#questionnaireError').removeClass('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            $('#questionnaire-iframe').addClass('d-none');
            $('#questionnaireError').removeClass('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          $('#questionnairePending').addClass('d-none');
          $('#questionnaireError').removeClass('d-none');
        }, 5000);
        this.uninstall();
      }
    }
    );
  };
});
